import classNames from 'classnames';
import Proptypes from 'prop-types';
import React from 'react';

export default class Loading extends React.Component {
  static propTypes = {
    isLoading: Proptypes.bool,
    className: Proptypes.string,
  };
  render() {
    const {isLoading, className} = this.props;
    return (
      isLoading && (
        <div className={classNames('epic-common-loading-container', className)}>
          <div className="epic-common-spinner-icon" />
        </div>
      )
    );
  }
}
